import { StreamChat } from 'stream-chat';
import cloneDeep from 'lodash/cloneDeep';
import has from 'lodash/has';
import store from './store';

// // // // // // // // // // // // // // // // // // // // // // // // // // // // // //
let streamClient = null;
const authState = store.state.auth;
// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //

class ChatData {
  static init(newRegister = true) {
    const userName =
      authState && authState.currentUser && authState.currentUser.roles
        ? authState.currentUser.roles.isAdmin
          ? authState.currentUser.admin.user
          : authState.currentUser.roles.isTrainer
          ? authState.currentUser.trainer.user
          : null
        : null;

    const userId =
      authState && authState.currentUser && authState.currentUser.roles
        ? authState.currentUser.roles.isAdmin
          ? authState.currentUser.admin._id
          : authState.currentUser.roles.isTrainer
          ? authState.currentUser.trainer._id
          : null
        : null;

    const userStreamToken =
      authState && authState.currentUser && authState.currentUser.roles
        ? authState.currentUser.roles.isAdmin
          ? authState.currentUser.admin.stream_chat_token
          : authState.currentUser.roles.isTrainer
          ? authState.currentUser.trainer.profile.stream_chat_token
          : null
        : null;

    if (
      userId &&
      userName &&
      userStreamToken &&
      authState.currentUser.streamAppId
    ) {
      // Init new stream chat
      streamClient = new StreamChat(authState.currentUser.streamAppId, {
        timeout: 10000,
      });
      streamClient.off(countUnread); // Remove event listener if any to prevent duplication
      streamClient.on(countUnread); // Add count unread event listener
      streamClient
        .setUser({ id: userId, name: userName }, userStreamToken)
        .then(() => {
          store.commit('auth/SET_UNREAD_COUNT', streamClient.user.unread_count);
        });
    }
    return (async () => {
      const allClientClone = store.state.client.allClientClone;
      if (streamClient && allClientClone && allClientClone.length > 0) {
        let offset = 0;
        const clinetsLength = store.state.client.allClientClone.length;
        const filter = {
          type: 'messaging',
          members: { $in: [`${streamClient.user.id}`] },
        };
        // Loop and fetch 30 channels and increment offset by 30 on every loop
        const channelsArray = [];
        for (let i = 0; i < clinetsLength; i += 30) {
          try {
            const channelsRes = await streamClient.queryChannels(
              filter,
              {},
              {
                watch: true,
                offset: offset,
                state: true,
                limit: 30,
              }
            );
            channelsArray.push(...channelsRes);
          } catch (err) {
            console.log('Error fetching chat data', err);
          }
          offset += 30;
        }
        // Prepare chatObj and chat data array
        this.chatData = channelsArray.map((channel) => {
          const channelUsers = Object.keys(channel.state.read);
          let clientId = '';
          if (channelUsers.length) {
            channelUsers.forEach((userId) => {
              if (channelUsers[userId] !== streamClient.user.id) {
                clientId = userId;
              }
            });
          }

          return {
            clientId: clientId,
            unreadMessages:
              channel.state.read[streamClient.user.id].unread_messages,
            latestMessage:
              channel.state.messages[channel.state.messages.length - 1],
            channel: channel,
            ...allClientClone.find((client) => client._id === clientId),
          };
        });
        if (newRegister) {
          const newClientsArr = await registerNewClients(this.chatData);
          const allClientsArr = [...this.chatData, ...newClientsArr];
          return allClientsArr;
        } else {
          return this.chatData;
        }

        //   const allClientsArrList =  sortClientsByUnread(allClientsArr);
        // return allClientsArr;
      }
    })();
  }
}

const registerNewClients = async (chatData) => {
  const newChatClients = [];
  const allClientClone = store.state.client.allClientClone;
  // Check for registered client and no chat or channel has been init (if ios missed init or client main view)
  if (allClientClone && allClientClone.length > 0) {
    for (let i = 0; i < allClientClone.length; i++) {
      const client = allClientClone[i];
      const clientId = client._id;
      const trainerId = client.trainer_id;
      const channelId = `${trainerId}_${clientId}`;
      const ifFromChatData = chatData.find(
        (channel) => channel.channel.id === channelId
      );
      if (
        chatData &&
        chatData.length > 0 &&
        !ifFromChatData &&
        ifFromChatData === undefined
      ) {
        // Check if client not in chatData array and registered (supposed to init)
        if (
          client.profile.lastSeen ||
          client.profile.last_seen ||
          (has(client.profile, 'successfulSignup') &&
            client.profile.successfulSignup)
        ) {
          try {
            const streamChatClient = streamClient;
            const userStreamChat = new StreamChat(
              authState.currentUser.streamAppId,
              {
                timeout: 10000,
              }
            );
            const clientStreamChatToken = client.profile.stream_chat_token;
            const clientId = client._id;
            if (clientStreamChatToken) {
              // Set new chat user
              await userStreamChat.setUser(
                { id: clientId, name: client.email },
                clientStreamChatToken
              );
              await userStreamChat.disconnect();

              // Set and create new channel chat user
              const channel = await streamChatClient.channel(
                'messaging',
                channelId,
                {
                  name: client.profile.firstName,
                  members: [`${clientId}`, `${trainerId}`],
                }
              );

              await channel.create();

              const result = {
                clientId: clientId,
                unreadMessages: channel.state.read[streamChatClient.user.id]
                  ? channel.state.read[streamChatClient.user.id].unread_messages
                  : 0,
                latestMessage:
                  channel.state.messages[channel.state.messages.length - 1],
                channel: channel,
                ...allClientClone.find((client) => client._id === clientId),
              };
              newChatClients.push(result);
            }
          } catch (err) {
            console.log('Faild to register new chat client', err);
          }
        }
      }
    }
  }
  return newChatClients;
};

const setClientUnreadFlag = async (client, chatData) => {
  const clientId = client._id;
  const trainerId = client.trainer_id;
  let result = null;
  const channelId = `${trainerId}_${clientId}`;
  const isRegistered =
    client.profile.lastSeen ||
    client.profile.last_seen ||
    (has(client.profile, 'successfulSignup') &&
      client.profile.successfulSignup);

  // Check if client exist in the chat data array
  if (chatData && chatData.length > 0) {
    result = cloneDeep(chatData.find((user) => user.channel.id === channelId));
  }

  let updateChannel = false; // To prevent multiple updates

  // Clinet channel exist, go ahead and check if name needs update
  if (result && !updateChannel && isRegistered) {
    if (result.channel.data.name !== client.profile.firstName) {
      await result.channel.update({ name: client.profile.firstName });
      // this.SET_UPDATE_CHAT_DATA(result); // Update vuex as well
    }
    if (
      client &&
      (!(
        client.hasUnreadMessages === undefined && result.unreadMessages === 0
      ) ||
        !(client.hasUnreadMessages === false && result.unreadMessages === 0)) &&
      client.hasUnreadMessages !== result.unreadMessages > 0
    ) {
      store.commit('client/setHasUnreadMessages', {
        client: client,
        hasUnreadMessages: result.unreadMessages > 0,
      });
    }
    updateChannel = true;
  }
};

const connectToChannel = async (client) => {
  const clientId = client._id;
  const trainerId = client.trainer_id;
  const channelId = `${trainerId}_${clientId}`;
  let error = null;
  let channel = null;
  let channelMessages = [];
  if (streamClient) {
    // Connect to the selected client channel
    const filter = {
      type: 'messaging',
      id: { $in: [channelId] },
    };

    let channels;
    try {
      channels = await streamClient.queryChannels(
        filter,
        {},
        {
          watch: true,
          state: true,
          limit: 1,
        }
      );
    } catch (e) {
      error = 'Faild to fetch chat data';
      console.log('Faild to fetch chat data');
    }

    if (channels.length > 0) {
      // Get all messages
      channel = channels[0];
      try {
        const { messages } = await channel.watch();
        channelMessages = messages;

        // Read all messages and update live channel state
        await channel.markRead();
        // Update client data unread state
        store.commit('client/setHasUnreadMessages', {
          client: client,
          hasUnreadMessages: false,
        });
      } catch (e) {
        error = 'Faild to fetch chat data';
        console.log('Faild to fetch chat data');
      }
    }
  }
  return { channelMessages, channel, error };
};

const reInitGlobalUnreadCount = () => {
  if (streamClient) {
    return streamClient.user.unread_count;
  }
  return false;
};

const getStreatmClient = () => {
  return streamClient;
};
export {
  ChatData,
  setClientUnreadFlag,
  connectToChannel,
  reInitGlobalUnreadCount,
  getStreatmClient,
};

// ===
// Private helpers
// ===

// Stream unread count event handler
function countUnread(event) {
  if (event.total_unread_count !== undefined) {
    store.commit('auth/SET_UNREAD_COUNT', event.total_unread_count);
    if (event.type === 'message.new' && event.unread_count > 0) {
      showNotification(event);
    }
  }
}
function showNotification(event) {
  if (window.Notification && Notification.permission === 'granted') {
    const notification = new Notification(event.message.user.name, {
      body: event.message.text,
    });
    notification.onclick = () => {
      notification.close();
    };
  }
}

/*
function sortClientsByUnread(clients) {
  return clients;
   const alphaSorted = clients.sort(function(a, b) {
    if (
      a.profile &&
      b.profile &&
      a.profile.firstName &&
      b.profile.firstName &&
      a.profile.firstName.toLowerCase() < b.profile.firstName.toLowerCase()
    ) {
      return -1;
    }
    if (
      a.profile &&
      b.profile &&
      a.profile.firstName &&
      b.profile.firstName &&
      a.profile.firstName.toLowerCase() > b.profile.firstName.toLowerCase()
    ) {
      return 1;
    }
    return 0;
  });

  return alphaSorted.sort(function(a, b) {
    if (b.unreadMessages < a.unreadMessages) {
      return -1;
    }
    return 0;
  });
} */
